/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { TenantSocialLinks } from './TenantSocialLinks';
import {
    TenantSocialLinksFromJSON,
    TenantSocialLinksFromJSONTyped,
    TenantSocialLinksToJSON,
} from './TenantSocialLinks';

/**
 * Tenant-self-serve subset of tenant configuration, editable by tenant admins (unlike the manager-only Tenant record). Intended home for miscellaneous per-tenant options.
 * @export
 * @interface TenantOptions
 */
export interface TenantOptions {
    /**
     * 
     * @type {TenantSocialLinks}
     * @memberof TenantOptions
     */
    social_links?: TenantSocialLinks;
}

/**
 * Check if a given object implements the TenantOptions interface.
 */
export function instanceOfTenantOptions(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function TenantOptionsFromJSON(json: any): TenantOptions {
    return TenantOptionsFromJSONTyped(json, false);
}

export function TenantOptionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): TenantOptions {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'social_links': !exists(json, 'social_links') ? undefined : TenantSocialLinksFromJSON(json['social_links']),
    };
}

export function TenantOptionsToJSON(value?: TenantOptions | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'social_links': TenantSocialLinksToJSON(value.social_links),
    };
}

